import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetOrders extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Orders</h1>
				<p>This method retrieves a list of orders you received or placed.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> /orders </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> direction </td>
							<td> String </td>
							<td> Y </td>
							<td> The direction of the order to get. Acceptable values are:<br/>- "out": Gets placed orders.<br/>- "in": Gets received orders. (default) </td>
						</tr>
						<tr>
							<td> status </td>
							<td> String </td>
							<td> Y </td>
							<td> The status of the order to include or exclude. <br/>- If you don't specify this value, this method retrieves orders in any status.<br/>- You can pass a comma-separated string to specify multiple status to include/exclude.<br/>- You can add a minus(-) sign to specify a status to exclude </td>
						</tr>
						<tr>
							<td> filed </td>
							<td> Boolean </td>
							<td> Y </td>
							<td> Indicates whether the result retries filed or un-filed orders. Acceptable values are:<br/>- "true" <br/>- "false": (default) </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a list of the the summary of an order resource as "data" in the response body.</p>	
				<p>Each entry in the list includes followings:</p>
				<ul>
					<li>order_id</li>
					<li>date_ordered</li>
					<li>seller_name</li>
					<li>store_name</li>
					<li>buyer_name</li>
					<li>total_count</li>
					<li>unique_count</li>
					<li>status</li>
					<li>payment.method</li>
					<li>payment.status</li>
					<li>payment.date_paid</li>
					<li>payment.currency_code</li>
					<li>cost.subtotal</li>
					<li>cost.grandtotal</li>
					<li>cost.currency_code</li>
				</ul>
				<p>To retrieve additional properties, see the <a href="?page=get-order">Get Order</a>.</p>
				<h4>Example</h4>
				<ul>
					<li>
						GET /orders
						<ul>
							<li>Retrieves a list of received orders</li>
						</ul>
					</li>
					<li>
						GET /orders?direction=out
						<ul>
							<li>Retrieves a list of placed orders</li>
						</ul>
					</li>
					<li>
						GET /orders?status=pending,completed
						<ul>
							<li>Retrieves PENDING or COMPLETED received orders</li>
						</ul>
					</li>
					<li>
						GET /orders?status=-purged
						<ul>
							<li>Retrieves a list of received orders not in PURGED status</li>
						</ul>
					</li>
					<li>
						GET /orders?filed=true&status=completed
						<ul>
							<li>Retrieves a list of received and filed orders in COMPETED status</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}